import {useDispatch} from "react-redux";
import {useCompanySelector} from "../../../../redux/reducers/companyReducer";
import {filterCompanies, clearCompaniesFilter} from "../../../../redux/actions/companyActions";
import {useEffect} from "react";

export const useController = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        return (() => {
            dispatch(clearCompaniesFilter());
        })
    }, []);

    const {filteredCompanies} = useCompanySelector();

    return {
        filteredCompanies,
        filterCompanies: (filterValues) => {
            dispatch(filterCompanies(filterValues))
        },
    };
};